import moment from 'moment';

import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/races';

const raceStatusMap = {
  "R": "Running",
  "P": "Pending",
  "F": "Finished",
}
const ListRaces = () => {
  const filter = {};

  return (
    <ListResource
    {...{
      searchable: true,
      api,
      sort: { date: -1 },
      filter,
      actions: {
        create: false,
        fileExport: true,
      //   fileImport: { url: '/api/site/races/files' },
      },
      cols: [
        { key: 'date', sortable: true, children: 'Date', getter(v) {
          return (
            <span>{v ? moment(v).format('yyyy/YY/DD hh:mm:ss') : ''}</span>
          )
        }},
        { key: 'name', sortable: true, children: 'Name' },
        { key: 'location', sortable: true, children: 'Location' },
        { 
          key: 'status', 
          getter(v) {
            return (
              <span>{raceStatusMap[v]||v}</span>
            );
          },
        },
      ],
      // ctrls: [
      //   <select
      //     className="custom-select"
      //     key={0}
      //     value={location}
      //     onChange={(e) => setLocation(e.target.value)}
      //   >
      //     <option value="">Select Attribute</option>
      //     {attr.map((a) => (
      //       <option key={a} value={a}>{a}</option>
      //     ))}
      //   </select>,
      // ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
  );
};

export default ListRaces;
